import { render, staticRenderFns } from "./allowed-times.vue?vue&type=template&id=26871aaf&"
import script from "./allowed-times.vue?vue&type=script&lang=js&"
export * from "./allowed-times.vue?vue&type=script&lang=js&"
import style0 from "./allowed-times.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
